import styled from "styled-components";
import { P, media } from "@nested/nested-react-components";

const QuoteStyle = styled(P)`
  font-weight: ${({ theme }) => theme.font.bold};
  font-size: 30px !important;
  line-height: 1.6 !important;

  border-left: 5px solid #9df6df;
  text-align: left;
  padding-left: 10px;
  margin-bottom: ${({ theme }) => theme.padding.base};

  &::after {
    content: " ”";
  }

  &::before {
    content: "“ ";
  }

  ${media.xl`
    border-left: 10px solid #9df6df;
    padding-left: 30px;
    margin: 40px 0 40px -40px;
  `};
`;

const Quote = (props) => <QuoteStyle {...props} as="blockquote" />;

export { Quote };
